import React, { useMemo } from "react";
import { Button, Drawer } from "antd";
import ShopTable from "./ShopTable"; // Import ShopTable
import ProductTable from "./ProductTable"; // Import ProductTable

const ItemSelectionDrawer = ({
  state = {},
  header,
  items = [],
  isShow,
  isLoading = false,
  closable = true,
  isSingleSelect = false, // control selection mode
  tableType, // determine the table type
  confirmBtnText,
  isConfirmBtnDisabled = false,
  onConfirm,
  onClose,
  rowDisablePredicate = () => false,
}) => {
  const { data = [], onChange } = state;

  // Calculate tableData with 'selected' field based on selectedItemIds
  const tableData = useMemo(() => {
    return items.map((item) => ({
      ...item,
      selected: data.includes(item.id),
    }));
  }, [items, data]);

  // Handle select by updating the 'selected' field
  const handleSelect = (itemId) => {
    let updatedTableData = [...tableData];

    if (isSingleSelect) {
      // If single select is enabled, set all others to false
      updatedTableData = updatedTableData.map((item) => ({
        ...item,
        selected: item.id === itemId, // Only the selected item will be true
      }));
    } else {
      // Toggle the selected value for the item with the matching itemId
      updatedTableData = updatedTableData.map((item) => ({
        ...item,
        selected: item.id === itemId ? !item.selected : item.selected,
      }));
    }

    // Update selectedItemIds and selectedItems accordingly
    onChange(
      updatedTableData.filter((item) => item.selected).map((item) => item.id),
      updatedTableData
    );
  };

  // Determine which table to render based on the tableType prop
  const renderTable = () => {
    switch (tableType) {
      case "shop":
        return <ShopTable data={tableData} canSelect onSelect={handleSelect} />;
      case "product":
        return (
          <ProductTable data={tableData} canSelect onSelect={handleSelect} rowDisablePredicate={rowDisablePredicate} />
        );
      default:
        return null; // or a fallback UI
    }
  };

  return (
    <Drawer
      open={isShow}
      title={header}
      width="auto"
      onClose={onClose}
      closable={closable}
      extra={
        <Button type="primary" size="large" loading={isLoading} disabled={isConfirmBtnDisabled} onClick={onConfirm}>
          {confirmBtnText}
        </Button>
      }
    >
      {renderTable()} {/* Render the appropriate table */}
    </Drawer>
  );
};

export default ItemSelectionDrawer;
